import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=12b827be&"
import script from "./SummaryCard.vue?vue&type=script&lang=ts&"
export * from "./SummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSeparator}, component.options.components || {})
